const appEnvironments = ['development', 'preview', 'staging', 'production', 'test'] as const

export type AppEnvironment = (typeof appEnvironments)[number]

function isAppEnvironment(value: string | undefined): value is AppEnvironment {
  return Boolean(value) && appEnvironments.includes(value as AppEnvironment)
}

export function resolveAppEnvironment(): AppEnvironment {
  const explicit = process.env.NEXT_PUBLIC_APP_ENV ?? process.env.APP_ENV
  if (isAppEnvironment(explicit)) return explicit

  if (process.env.NODE_ENV === 'test') return 'test'
  if (process.env.NODE_ENV === 'production') return 'production'

  return 'development'
}

export function resolveSentryEnvironment() {
  return process.env.SENTRY_ENVIRONMENT?.trim() || resolveAppEnvironment()
}

export function resolveSentryRelease() {
  return (
    process.env.SENTRY_RELEASE?.trim() ||
    process.env.VERCEL_GIT_COMMIT_SHA?.trim() ||
    process.env.GITHUB_SHA?.trim() ||
    undefined
  )
}

export function resolveDeploymentUrl() {
  const vercelUrl = process.env.VERCEL_URL?.trim()
  if (vercelUrl) {
    return vercelUrl.startsWith('http://') || vercelUrl.startsWith('https://') ? vercelUrl : `https://${vercelUrl}`
  }

  return process.env.NEXT_PUBLIC_APP_URL?.trim() || undefined
}
